var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSymbolGitMedium(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 107,
    viewBox: "0 0 107 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_219_4773)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.69531 29.5234C5.69531 16.2686 16.4405 5.52344 29.6953 5.52344H77.6953C90.9501 5.52344 101.695 16.2686 101.695 29.5234V77.5234C101.695 90.7783 90.9501 101.523 77.6953 101.523H29.6953C16.4405 101.523 5.69531 90.7783 5.69531 77.5234V29.5234Z",
    fill: "url(#paint0_linear_219_4773)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6988 51.1008C29.3608 52.4388 29.3608 54.6081 30.6988 55.946L51.2727 76.52C52.6107 77.8579 54.7799 77.8579 56.1179 76.52L76.6918 55.946C78.0298 54.6081 78.0298 52.4388 76.6918 51.1008L56.1179 30.5269C54.7799 29.1889 52.6107 29.1889 51.2727 30.5269L30.6988 51.1008ZM45.0108 36.8554L47.0942 34.772L52.6156 40.2933C52.9568 40.1876 53.3195 40.1306 53.6954 40.1306C55.7073 40.1306 57.3383 41.7616 57.3383 43.7735C57.3383 44.1494 57.2813 44.5121 57.1756 44.8533L62.6999 50.3776C63.0529 50.2636 63.4295 50.202 63.8204 50.202C65.8323 50.202 67.4633 51.833 67.4633 53.8449C67.4633 55.8568 65.8323 57.4877 63.8204 57.4877C61.8085 57.4877 60.1776 55.8568 60.1776 53.8449C60.1776 53.31 60.2929 52.8021 60.4999 52.3445L55.3562 47.2008V60.5125C56.533 61.1163 57.3383 62.3419 57.3383 63.7556C57.3383 65.7675 55.7073 67.3985 53.6954 67.3985C51.6836 67.3985 50.0526 65.7675 50.0526 63.7556C50.0526 62.1963 51.0323 60.8658 52.4097 60.3461V47.1829C51.0323 46.6632 50.0526 45.3328 50.0526 43.7735C50.0526 43.2242 50.1741 42.7034 50.3918 42.2364L45.0108 36.8554Z",
    fill: "url(#paint1_linear_219_4773)",
    fillOpacity: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_219_4773",
    x: 0.695312,
    y: 0.523438,
    width: 106,
    height: 106,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_219_4773"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_219_4773",
    x1: 53.6953,
    y1: 5.52344,
    x2: 53.6953,
    y2: 101.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9EBFF",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_219_4773",
    x1: 53.6953,
    y1: 29.5234,
    x2: 53.6953,
    y2: 77.5234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9EBFF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9EBFF",
    stopOpacity: 0.6
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolGitMedium);
export default __webpack_public_path__ + "static/media/symbol-git-medium.b1c8eba354769c658b22aebaaf79edcc.svg";
export { ForwardRef as ReactComponent };